// extracted by mini-css-extract-plugin
export default {"page":"Class_page__5w9qW","classContainer":"Class_classContainer__koiLm","container":"Class_container__WZl-E","form":"Class_form__BAdZ5","studentsList":"Class_studentsList__N4IaQ"};